export const getHasNasuAddedFunds = (state) =>
  state.nasuAddedFunds.nasuAddedFundInitialized;
